<wdpr-modal
  #uploadMeasurementsModal
  hide-close-icon
  disable-close-on-background
  >
  <h5 slot="title">Upload Cast Member Measurements</h5>

  <div slot="body">
    <div class="download-template">
      <a id="download" href="/assets/files/cast-measurements-template.csv" download>
        <i class="di di-download di14"></i> Download Template
      </a>
    </div>
    <div
      appFileUpload
      id="drop-area"
      class="d-flex flex-column flex-row justify-content-center align-items-center upload-container"
      (fileDropped)="onFileDropped($event)"
      >
      <h5>Select a CSV File</h5>
      <p>
        Drag and drop your file here, or
        <label class="link">
          <input id="file-input" type="file" (change)="onBrowseFiles($event)" accept=".csv" hidden />
          browse
        </label>
      </p>
    </div>
    @if (uploadErrors.errMsg) {
      <div class="form-control-error upload-errors">
        <i class="fa fa-exclamation-triangle"></i>&nbsp;
        <span class="warning-message"><strong>{{ uploadErrors.errMsg }}</strong></span>
        @if (uploadErrors.pernrs.length > 0) {
          <ul>
            @for (pernr of uploadErrors.pernrs; track pernr) {
              <li class="warning-message">{{ pernr }}</li>
            }
          </ul>
        }
      </div>
    }
  </div>

  <wdpr-button class="default me-0 ms-0" slot="buttons" theme="primary" (click)="close()" [disabled]="disabledDone">Done</wdpr-button>
  <wdpr-button class="default me-2 ms-0" slot="buttons" theme="secondary" (click)="close()">Cancel</wdpr-button>
</wdpr-modal>

<app-toast></app-toast>
